import { createRouter, createWebHistory } from 'vue-router'

// Modules
import Home from 'ROUTER/modules/home.js'
import Select from 'ROUTER/modules/select.js'
import Localguide from 'ROUTER/modules/localguide.js'
import Policy from 'ROUTER/modules/policy.js'
import About from 'ROUTER/modules/about.js'
import Blogs from 'ROUTER/modules/blogs.js'

const routes = [
    ...Home,
    ...Select,
    ...Localguide,
    ...Policy,
    ...About,
    ...Blogs
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

export default router
